/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { LegalEntityValidationService } from '../common/legal-entity-validation.service';
import { inject, Injectable } from '@angular/core';
import { VendorResourceService } from '@well/resource-services';

@Injectable()
export class DelLegalEntityValidationService implements LegalEntityValidationService {
  resourceService = inject(VendorResourceService);
  exists(country: string, uniqueIdentificationNumber: string) {
    const numericId = uniqueIdentificationNumber.replace(/\D/g, '');
    return this.resourceService.vendorExists(country, numericId);
  }
}
